import { useGetEmployersForSelect } from 'queries';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ControlledSelect } from 'components/shared';

import { useGetEmployerOptions } from '../hooks/useGetEmployerOptions';

export interface Props {
  handleSelect?: (value: string | number, label: string | undefined) => void;
}

export const EmployerSelect = ({ handleSelect }: Props) => {
  const options = useGetEmployerOptions();
  const { data: employers } = useGetEmployersForSelect();
  const { t } = useTranslation('common', {
    keyPrefix: 'employerCostSettings.details.general'
  });
  const { control } = useFormContext();

  return (
    <ControlledSelect
      handleSelect={(value) => {
        handleSelect?.(
          value,
          employers?.find((item) => value === item?.employerId)?.nameBrief
        );
      }}
      control={control}
      variant="outlined"
      label={t('employer_name_label')}
      name="employerId"
      options={options}
    />
  );
};
